import { createPortal } from 'react-dom';
import React from 'react';

const Portal = ({ children }: { children: React.ReactNode }) => {
    return createPortal(children, document.body);
};
export { Portal };
